import { Box, useMultiStyleConfig } from '@chakra-ui/react';
import React from 'react';

import ImageHandler from '../ImageHandler';

interface FeatureBannerProps {
  image: StaticImageDef | React.ReactElement;
  leftFeature: React.ReactElement;
  rightFeature: React.ReactElement;
}

const FeatureBanner: React.FC<FeatureBannerProps> = ({
  leftFeature,
  rightFeature,
  image,
}) => {
  const Styles = useMultiStyleConfig('FeatureBanner', {});

  return (
    <Box sx={Styles.container}>
      <Box sx={Styles.leftFeature}>{leftFeature}</Box>
      <Box sx={Styles.image}>
        <ImageHandler image={image} />
      </Box>
      <Box sx={Styles.rightFeature}>{rightFeature}</Box>
    </Box>
  );
};

export default FeatureBanner;
